// @ts-ignore
import ThemeInstance from "services/constants/theme";
import {Theme} from "@material-ui/core";

const theme = ThemeInstance.theme as Theme;

export {theme};
